import { PageHeader } from 'src/components';

export function UsageAndMetricsPage() {
  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <PageHeader title="Usage & metrics" description="" />
    </section>
  );
}
